import request from "@/http/request"
import {
  selectHumanList,
  batchAuditHuman,
  exportHuman,
  batchHumanAuditEx
} from '@/http/api'

export const selectHuman = (data) => {
    return request({
        url: selectHumanList,
        data
    })
}
export const batchAuditHumanSet = (data) => {
  return request({
      url: batchAuditHuman,
      data
  })
}
export const exportHumanSet = (data) => {
  return request({
      url: exportHuman,
      data
  })
}
export const batchHumanAudit = (data) => {
  return request({
      url: batchHumanAuditEx,
      data
  })
}